import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router";

import { useSession } from "@/hooks/use-session";

export function useSessionRedirect(): void {
  const { session } = useSession();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const previousSessionRef = useRef<Session | null>(session);

  useEffect(() => {
    const previousSession = previousSessionRef.current;
    if (previousSession && !session && pathname !== "/") {
      navigate("/", { replace: true });
    }

    previousSessionRef.current = session;
  }, [session, navigate, pathname]);
}
